import { call, put, takeEvery } from "redux-saga/effects"
import { FORM_NAMES } from  "constants/index"
import { showToast} from "../../utils";
import {
  GET_DOMAINS,
  GET_DOMAIN,
  DELETE_DOMAIN,
  CREATE_DOMAIN,
  UPDATE_DOMAIN,
} from "./actionTypes"
import {
  getDomainsSuccess,
  getDomainsFail,
  getDomainSuccess,
  getDomainFail,
  deleteDomainSuccess,
  deleteDomainFail,
  hideDeleteModal,
  createDomainSuccess,
  createDomainFail,
  updateDomainSuccess,
  updateDomainFail
} from "./actions"

import { get, post, del, axiosPut } from "helpers/api_helper"
import * as url from "helpers/url_helper"

function* fetchDomains({ payload: params }) {
  try {
    const response = yield get(url.GET_DOMAINS_URL, params);
    yield put(getDomainsSuccess(response))
  } catch (error) {
    yield put(getDomainsFail(error))
    showToast('error', error, "Error");
  }
}

function* fetchDomain({ payload: params }) {
  try {
    const response = yield get(url.GET_DOMAIN_URL + params.params.id);
    yield put(getDomainSuccess(response))
  } catch (error) {
    yield put(getDomainFail(error));
    showToast('error', error, "Error");
  }
}

function* createDomain({ payload }) {
  try {
    yield post(url.CREATE_DOMAIN_URL, payload);
    yield put(createDomainSuccess());
    showToast('success', 'The domain was created!', 'Success');
    window.location.href='/domains';
  } catch (error) {
    yield put(createDomainFail(error));
    showToast('error', error, "Error");
  }
}

function* updateDomain({ payload }) {
  try {
    yield axiosPut(url.UPDATE_DOMAIN_URL + payload.id, payload);
    yield put(updateDomainSuccess());
    showToast('success', 'The domain was updated!', 'Success');
  } catch (error) {
    yield put(updateDomainFail(error));
    showToast('error', error, "Error");
  }
}

function* deleteDomain({ payload }) {
  try {
    yield del(url.DELETE_DOMAIN_URL + payload.params.id);
    yield put(deleteDomainSuccess());
    yield put(hideDeleteModal());
    showToast('success', 'The domain was deleted!', 'Success');
  } catch (error) {
    yield put(deleteDomainFail(error));
    showToast('error', error, "Error");
  }
}

function* domainsSaga() {
  yield takeEvery(GET_DOMAINS, fetchDomains);
  yield takeEvery(GET_DOMAIN, fetchDomain);
  yield takeEvery(CREATE_DOMAIN, createDomain);
  yield takeEvery(DELETE_DOMAIN, deleteDomain);
  yield takeEvery(UPDATE_DOMAIN, updateDomain);
}

export default domainsSaga()
